<template>
    <b-modal id="editModal" ref="modal" title="Edit Variety Group" v-model="show" @ok="handleSubmit" @hide="close" @shown="focusNameInput">

        <div class="form-group">
            <label>Variety Group Name</label>
            <div class="position-relative">
                <input type="text" ref="nameInput" name="name" v-validate="{required: true}" class="form-control" v-model="name">
                <div class="invalid-feedback" v-if="errors.has('name')">{{ errors.first('name') }}</div>
                <i class="form-group__bar"></i>
            </div>
        </div>

        <template slot="modal-footer">
            <button class="btn btn-link text-danger mr-auto" @click="handleDelete" v-if="!varietyGroup.deleted_at">
                Disable
            </button>
            <button class="btn btn-link text-danger mr-auto" @click="handleRestore" v-if="varietyGroup.deleted_at">
                Restore
            </button>
            <button class="btn btn-secondary" @click="close">
                Cancel
            </button>
            <button class="btn btn-primary" :disabled="okDisabled" @click="handleSubmit">
                Save
            </button>
        </template>
    </b-modal>
</template>


<script>
import deleteVarietyGroupMutation from '@views/VarietyGroups/EditModal/mutationDeleteVarietyGroup.graphql';
import restoreVarietyGroupMutation from '@views/VarietyGroups/EditModal/mutationRestoreVarietyGroup.graphql';
import updateVarietyGroupMutation from '@views/VarietyGroups/EditModal/mutationUpdateVarietyGroup.graphql';

export default {
  name: 'edit-modal',
  apollo: {},
  props: {
    varietyGroup: {
      type: Object,
      required: true,
    },
    close: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      name: this.varietyGroup.name,
      show: true,
      loading: 0,
    };
  },
  computed: {
    okDisabled() {
      return this.name.length === 0;
    },
  },
  methods: {
    handleSubmit() {
      if (this.okDisabled) {
        return false;
      }
      this.errors.remove('global');
      this.$validator.validateAll().then(validationWasSuccessful => {
        if (!validationWasSuccessful) {
          return;
        }

        this.$apollo
          .mutate({
            mutation: updateVarietyGroupMutation,
            variables: {
              input: {
                id: this.varietyGroup.id,
                name: this.name,
              },
            },
            optimisticResponse: {
              __typename: 'Mutation',
              updateVarietyGroup: {
                ...this.varietyGroup,
                name: this.name,
              },
            },
          })
          .then(() => {
            this.$notifySuccess('Variety group updated!');
            this.close();
          })
          .catch(err => {
            this.$mapGraphQLError(err);
          })
          .catch(err => {
            console.error(err);
            this.$notifyFailure(
              'Unfortunately, we were unable to do that!',
            );
          });
      });
    },
    handleDelete() {
      this.$apollo
        .mutate({
          mutation: deleteVarietyGroupMutation,
          variables: {
            input: {
              id: this.varietyGroup.id,
            },
          },
        })
        .then(() => {
          this.$notifySuccess('Variety group disabled!');
          this.close();
        })
        .catch(err => {
          this.$mapGraphQLError(err);
        })
        .catch(err => {
          console.error(err);
          this.$notifyFailure(
            'Unfortunately, we were unable to do that!',
          );
        });
    },
    handleRestore() {
      this.$apollo
        .mutate({
          mutation: restoreVarietyGroupMutation,
          variables: {
            input: {
              id: this.varietyGroup.id,
            },
          },
          optimisticResponse: {
            __typename: 'Mutation',
            restoreVarietyGroup: {
              ...this.varietyGroup,
              deleted_at: null,
            },
          },
        })
        .then(() => {
          this.$notifySuccess('Variety group restored!');
          this.close();
        })
        .catch(err => {
          this.$mapGraphQLError(err);
        })
        .catch(err => {
          console.error(err);
          this.$notifyFailure(
            'Unfortunately, we were unable to do that!',
          );
        });
    },
    focusNameInput() {
      this.$refs.nameInput.focus();
    },
  },
};
</script>
